import { Component, input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatRadioChange } from '@angular/material/radio';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

import { Option } from '../../../models/option.model';

@Component({
  selector: 'eiq-input-radio-group',
  templateUrl: 'input-radio-group.component.html',
  styleUrls: ['input-radio-group.component.scss']
})
export class InputRadioGroupComponent implements OnInit {
  appearance = input<'row' | 'column'>('row');
  formCtrl = input(null, {
    transform: (abstractCtrl: AbstractControl) => abstractCtrl as FormControl
  });
  label = input<string>();
  options = input<Option<unknown>[]>([]);
  palette = input<ThemePalette>('primary');
  testId$ = input.required<string>({ alias: 'testId' });
  tooltip = input<string>(null);

  faInfoCircle = faInfoCircle;

  selectedValue: unknown;

  constructor() {}

  ngOnInit(): void {
    this.selectedValue = this.formCtrl().value;
  }

  mapToControl(valueSelected: any): void {
    this.formCtrl().setValue((valueSelected as MatRadioChange).value);
  }
}
